module.exports = __webpack_public_path__ + "img/driving_preview.d52605e5.jpg";